export default "__VITE_ASSET__BMj0w2Rr__"